import React from 'react';
import LoadingAnimation from './LoadingAnimation';

const LoadingOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999]"
      style={{ touchAction: 'none' }}
      onTouchMove={(e) => e.preventDefault()}
      onClick={(e) => e.preventDefault()}
    >
      <div className="bg-white/90 backdrop-blur rounded-2xl shadow-xl max-w-md w-full mx-4 animate-fade-in">
        <LoadingAnimation />
      </div>
    </div>
  );
};

export default LoadingOverlay; 